let activeTitle = '';
// const steps = ['Personal details', 'Eligibility', 'Supporting details', 'Bank details', 'Review'];

export const getStepListContent = (steps, currentStep) => {
    return steps.map((content, index) => {
        const i = index + 1;
        let status = currentStep < i ? 'todo' : 'completed';

        if (i === currentStep) {
            status = 'current';
            activeTitle = content;
        }

        return {
            content,
            status,
        };
    });
};

export const getActiveStepListTitle = () => activeTitle;
